module.exports = __webpack_public_path__ + "static/media/video.55de02e0.mp4";